import {useState} from 'react';
import {useNavigate, useSearchParams} from 'react-router-dom';
import {PageTitle} from '../../../_metronic/layout/core';
import Level3Title from '../../../app/common/components/title/Level3Title';

interface NsFormValues {
  ns1: string;
  ns2: string;
  ns3: string;
  ns4: string;
  ip1: string;
  ip2: string;
  ip3: string;
  ip4: string;
}

const DomaineNsPage = (): JSX.Element => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const domaineName = searchParams.get('domaine') ?? 'exemple.fr';

  const [values, setValues] = useState<NsFormValues>({
    ns1: 'ns1.sd-france.net',
    ns2: 'ns2.sd-france.net',
    ns3: '',
    ns4: '',
    ip1: '',
    ip2: '',
    ip3: '',
    ip4: '',
  });

  const handleChange = (field: keyof NsFormValues) => (e: React.ChangeEvent<HTMLInputElement>) => {
    setValues(prev => ({...prev, [field]: e.target.value}));
  };

  const handleCancel = () => navigate(-1);

  const nsFields: Array<{ns: keyof NsFormValues; ip: keyof NsFormValues; label: string}> = [
    {ns: 'ns1', ip: 'ip1', label: '1'},
    {ns: 'ns2', ip: 'ip2', label: '2'},
    {ns: 'ns3', ip: 'ip3', label: '3'},
    {ns: 'ns4', ip: 'ip4', label: '4'},
  ];

  return (
    <>
      <PageTitle breadcrumbs={[]}>Modifier les NS — {domaineName}</PageTitle>

      <button
        type="button"
        className="btn btn-sm btn-outline btn-outline-primary btn-active-light-primary d-inline-flex align-items-center mb-5"
        onClick={handleCancel}
      >
        <i className="bi bi-arrow-left me-2" />
        Retour
      </button>

      <div className="notice d-flex bg-light-warning rounded border-warning border border-dashed p-6 mb-6 align-items-start">
        <i className="bi bi-exclamation-triangle fs-2tx text-warning me-4 flex-shrink-0" />
        <div className="d-flex flex-column flex-grow-1">
          <div className="fw-semibold text-gray-700 mb-4">
            Ce domaine n'est pas géré par nos services. Afin d'utiliser notre zone DNS, veuillez
            modifier les NS du domaine en{' '}
            <strong>ns1.celeste.fr / ns2.celeste.fr / ns3.celeste.fr</strong>
          </div>
          <div>
            <button
              type="button"
              className="btn btn-sm btn-warning d-inline-flex align-items-center"
            >
              <i className="bi bi-arrow-repeat me-2" />
              Basculer mon nom de domaine vers les serveurs de nom de Celeste
            </button>
          </div>
        </div>
      </div>

      <div className="card" style={{maxWidth: '900px'}}>
        <div className="card-header border-0 pt-6">
          <div className="card-title">
            <Level3Title title="Éditer les NS du domaine" />
          </div>
        </div>
        <div className="card-body pt-2">
          <div className="row gy-4 mb-8">
            {nsFields.map(({ns, ip, label}) => (
              <div key={label} className="col-12">
                <div className="row g-4 align-items-center">
                  <div className="col-md-6">
                    <label className="form-label fw-semibold text-gray-600">NS{label} :</label>
                    <input
                      type="text"
                      className="form-control form-control-sm"
                      value={values[ns]}
                      onChange={handleChange(ns)}
                      placeholder={`ns${label}.exemple.fr`}
                    />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label fw-semibold text-gray-600">
                      IP{label}{' '}
                      <span className="text-muted fw-normal">(Optionnel)</span> :
                    </label>
                    <input
                      type="text"
                      className="form-control form-control-sm"
                      value={values[ip]}
                      onChange={handleChange(ip)}
                      placeholder="0.0.0.0"
                    />
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="row">
            <div className="col-12 d-flex justify-content-end gap-3">
              <button type="button" className="btn btn-sm btn-primary">
                Valider
              </button>
              <button type="button" className="btn btn-sm btn-secondary" onClick={handleCancel}>
                Annuler
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default DomaineNsPage;
